import React from 'react';
import { I18n } from '@aws-amplify/core';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Col, Form, Image, InputNumber, Row } from 'antd';

import { useLibertyMutualSubStepsContext } from '../../context';
import { CustomLabel, CustomTooltip } from './CustomLabel';
import { TaskName } from '../../hooks/types/response';
import { SystemOfUnits } from '../../context/types';

const PUSH_HORIZONTAL_DISTANCE = 'https://kinebot-statics.s3.amazonaws.com/liberty-mutual/push-horizontal-distance.svg';
const PULL_HORIZONTAL_DISTANCE = 'https://kinebot-statics.s3.amazonaws.com/liberty-mutual/pull-horizontal-distance.svg';
const CARRY_HORIZONTAL_DISTANCE =
	'https://kinebot-statics.s3.amazonaws.com/liberty-mutual/carry-horizontal-distance.svg';

export const HorizontalDistance = () => {
	const { libertyMutual, decimalSeparator } = useLibertyMutualSubStepsContext();

	const systemOfUnitsToSymbolMapper: SystemOfUnits = {
		metric: 'm',
		imperial: 'ft'
	};

	const labelTitle = `${I18n.get('Horizontal distance')} (${
		systemOfUnitsToSymbolMapper[libertyMutual?.system_of_units?.name]
	})`;

	const tooltipSVGMapper = {
		[TaskName.lift]: '',
		[TaskName.lower]: '',
		[TaskName.push]: PUSH_HORIZONTAL_DISTANCE,
		[TaskName.pull]: PULL_HORIZONTAL_DISTANCE,
		[TaskName.carry]: CARRY_HORIZONTAL_DISTANCE
	};

	const TooltipContent = (
		<Row align="bottom">
			<Col xs={7}>
				<Image src={tooltipSVGMapper[libertyMutual.task.name]} alt={labelTitle} preview={false} width="80px" />
			</Col>
		</Row>
	);

	const label = (
		<CustomLabel
			icon={
				<CustomTooltip top={-115} left={14} content={TooltipContent} placement="topLeft">
					<InfoCircleOutlined style={{ fontSize: '0.65rem', marginLeft: '0.1rem' }} />
				</CustomTooltip>
			}
			title={labelTitle}
		/>
	);

	return (
		<Row>
			<Col xs={24}>
				<Form.Item
					name={['liberty_mutual_inputs', 'horizontal_distance']}
					label={label}
					labelCol={{ span: 24 }}
					rules={[
						{
							required: true,
							message: I18n.get('Insert an horizontal distance')
						}
					]}
				>
					<InputNumber min={0.1} width="50%" placeholder="0" decimalSeparator={decimalSeparator} />
				</Form.Item>
			</Col>
		</Row>
	);
};
